// Valor sessão
// export const textoInfo1 = (
//     <span>
//       O Investimento em cada sessão com o Dr. André Parreira é de R$130,00. Contudo, há alguns descontos:<br></br>
//       - Se forem realizadas pelo menos 4 sessões no mês, o valor fica R$120,00 por sessão;<br></br>
//       - Caso o pagamento seja realizado antes das sessões, o valor de cada uma fica R$ 110,00.
//     </span>
//   );

// export const textoInfo1 = 'Ofereço duas opções para tornar seu acompanhamento psicológico mais acessível e alinhado às suas necessidades: SESSÃO AVULSA – ideal para quem busca flexibilidade; PACOTE MENSAL – um formato pensado para quem deseja um acompanhamento contínuo com melhor custo-benefício. Cada pessoa tem uma jornada única, e o mais importante é encontrar o caminho que faça sentido para você. Para saber mais detalhes e entender qual opção melhor se encaixa no seu momento, é só entrar em contato através do WhatsApp!'

export const textoInfo1 = (
  <span>
    Cuidar da sua saúde mental nunca foi tão acessível! Você pode escolher a modalidade que melhor se adapta às suas necessidades:
    <br /><br />
    <strong>🔹 Sessão Avulsa:</strong> R$ 89,00 cada<br />
    <strong>🔹 Pacote com 4 Sessões:</strong> R$ 316,00  <span>(Cada sessão sai por R$ 79,00)</span><br />
    🔹 Obs.: <strong>1ª Sessão</strong> com valor reduzido | R$ 69,00.<br /><br />
    Se você estava esperando o momento certo para começar a terapia, essa é a sua oportunidade!
    {/* <em>Obs.: Em caso de agenda cheia, contamos com um sistema de Fila de Espera.</em> */}
  </span>
);

// Reembolso Convênio
// export const textoInfo2 = 'Por se tratar de um serviço de psicoterapia particular, é possível solicitar mensalmente um reembolso pelo seu convênio médico. O valor a ser reembolsado varia pelo plano e convênio da pessoa, contudo, todos são obrigados a reembolsar a psicoterapia. Para isso, temos uma equipe especializada, que explica todos os passos e disponibiliza os documentos necessários, da parte da clínica, para o processo do reembolso.'

// Formas de Pagamento
export const textoInfo2 = (
  <span>
    Ofereço formas de pagamento práticas e seguras, pensadas para facilitar o seu cuidado com a saúde emocional:
    <br /><br />
    🔹 <strong>Pix:</strong> Disponível para sessão avulsa ou pacote de sessões.
    <br />
    🔹 <strong>Cartão de Crédito:</strong> Para o pacote de 4 sessões, tornando o investimento mais acessível. Ou para sessões avulsas com o acréscimo de R$ 10,00 em cada sessão.
  </span>
);


// Plano de Saúde e Convênio
export const textoInfo3 = (
  <span>
    Atendo na modalidade de <strong>Reembolso</strong>. Cada plano de saúde define o percentual reembolsado, que pode variar de <strong>30% a 100%</strong> do valor investido. <strong>O reembolso é um direito do beneficiário</strong>, conforme regulamentação da ANS.<br /><br />
    É importante destacar que cada convênio estabelece quais documentos são necessários para a solicitação. Por isso, recomendamos que você entre em contato com o suporte do seu plano para confirmar os critérios.
  </span>
);

// Terapia On-line
export const textoInfo4 = (
  <span>
    Para realizar uma <strong>Psicoterapia On-line</strong>, é necessário apenas um dispositivo com acesso à internet — como celular, notebook ou tablet.<br/><br/>
    As sessões acontecem pela plataforma <strong>Google Meet</strong> e mantêm a mesma dinâmica, qualidade e confidencialidade do atendimento presencial.
  </span>
)

// Frequência e duração das sessões
export const textoInfo5 = (
  <span>
    As sessões têm duração de <strong>50 minutos</strong> e, inicialmente, acontecem com <strong>frequência semanal</strong>. Ao longo do processo terapêutico, a frequência pode ser ajustada de acordo com as necessidades individuais de cada pessoa.<br/><br/>
    O processo terapêutico respeita o <strong>ritmo de cada pessoa</strong>. Sua duração não é fixa e se ajusta conforme as necessidades, objetivos e o momento de vida de quem está em acompanhamento.
  </span>
)

// Agendamento
export const textoInfo6 = 'Todo o contato comigo é realizado pelo WhatsApp. Para agendamento, basta me encaminhar 3 opções de dia/horário que melhor te atende, para que assim, seja feito o alinhamento entre sua disponibilidade e a minha agenda.'